import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Footer from "../components/Footer";
import "./OrderHistoryPage.css";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const OrderHistoryPage = () => {
  const { token } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await fetch(`${API_URL}/orders/my`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Failed to fetch orders");
        const data = await res.json();
        setOrders(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, [token]);

  const formatDate = (iso) =>
    new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

  return (
    <div className="orders-page">
      <div className="orders-container">
        <h1 className="orders-title">Order History</h1>

        {loading && <p className="orders-loading">Loading your orders...</p>}
        {error && <p className="orders-error">{error}</p>}

        {!loading && orders.length === 0 && (
          <div className="orders-empty">
            <p>You haven't placed any orders yet.</p>
            <Link to="/products" className="orders-shop-btn">Start Shopping</Link>
          </div>
        )}

        <div className="orders-list">
          {orders.map((order) => (
            <div className="order-card" key={order.id}>
              <div className="order-card-header">
                <div>
                  <span className="order-id">Order #{order.id}</span>
                  <span className="order-date">{formatDate(order.created_at)}</span>
                </div>
                <span className={`order-status order-status--${order.status}`}>
                  {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                </span>
              </div>

              <div className="order-items">
                {order.items.map((item, idx) => (
                  <div className="order-item" key={idx}>
                    {item.image && (
                      <img src={item.image} alt={item.name} className="order-item-img" />
                    )}
                    <div className="order-item-info">
                      <p className="order-item-name">{item.name}</p>
                      <p className="order-item-meta">₹{item.price} × {item.quantity}</p>
                    </div>
                    <p className="order-item-subtotal">₹{item.subtotal}</p>
                  </div>
                ))}
              </div>

              <div className="order-card-footer">
                <div className="order-address">
                  <span>📍 </span>
                  {order.delivery_address.street}, {order.delivery_address.city},{" "}
                  {order.delivery_address.state} – {order.delivery_address.pin_code}
                </div>
                <div className="order-total">
                  Total: <strong>₹{Number(order.total_amount).toFixed(2)}</strong>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default OrderHistoryPage;
